import { clearSessionExpiredData, readSessionExpiredAllowPath } from './storage';

const SESSION_EXPIRED_MODAL_OPEN_KEY = 'sessionExpiredModalOpen' as const;
const SESSION_EXPIRED_ON_RELOAD_KEY = 'sessionExpiredOnReload' as const;
const WAS_LOGGED_IN_KEY = 'wasLoggedIn' as const;

const readBool = (key: string): boolean => window.sessionStorage.getItem(key) === 'true';
const setBool = (key: string, value: boolean): void => {
  if (value) window.sessionStorage.setItem(key, 'true');
  else window.sessionStorage.removeItem(key);
};

export const isSessionExpiredModalOpen = (): boolean => readBool(SESSION_EXPIRED_MODAL_OPEN_KEY);
export const setSessionExpiredModalOpen = (): void => setBool(SESSION_EXPIRED_MODAL_OPEN_KEY, true);
export const clearSessionExpiredModalOpen = (): void => setBool(SESSION_EXPIRED_MODAL_OPEN_KEY, false);

export const isSessionExpiredOnReload = (): boolean => readBool(SESSION_EXPIRED_ON_RELOAD_KEY);
export const setSessionExpiredOnReload = (): void => setBool(SESSION_EXPIRED_ON_RELOAD_KEY, true);
export const clearSessionExpiredOnReload = (): void => setBool(SESSION_EXPIRED_ON_RELOAD_KEY, false);

export const wasLoggedIn = (): boolean => readBool(WAS_LOGGED_IN_KEY);
export const setWasLoggedIn = (): void => setBool(WAS_LOGGED_IN_KEY, true);
export const clearWasLoggedIn = (): void => setBool(WAS_LOGGED_IN_KEY, false);

export const hasSessionExpiredReloadSignals = (): boolean =>
  isSessionExpiredOnReload() || isSessionExpiredModalOpen() || Boolean(readSessionExpiredAllowPath());

export const normalizeSessionExpiredReloadState = (): boolean => {
  if (!hasSessionExpiredReloadSignals()) return false;
  setSessionExpiredOnReload();
  clearSessionExpiredModalOpen();
  clearSessionExpiredData();
  return true;
};
